import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment.prod';
import { Product } from '../domains-product/product';

// 🔹 Interfaz para la respuesta de getProducts
export interface ProductsResponse {
  productos: Product[];
}

@Injectable({
  providedIn: 'root'
})
export class SrvProductService {
  private url = 'product_api/product/';

  constructor(private http: HttpClient) {}

  private getHeaders(): HttpHeaders {
    return new HttpHeaders({ 'Content-Type': 'application/json' });
  }

  getProducts(filtro: string = ''): Observable<ProductsResponse> {
    const url = `${environment.url_web_services_path}${this.url}?filtro=${filtro}`;
    console.log('🔹 URL que se llama al backend:', url);
    return this.http.get<ProductsResponse>(url, { headers: this.getHeaders() });
  }

  getProduct(rowid: number): Observable<Product> {
    const url = `${environment.url_web_services_path}${this.url}${rowid}/`;
    return this.http.get<Product>(url, { headers: this.getHeaders() });
  }

  createProduct(product: Product): Observable<Product> {
    const url = `${environment.url_web_services_path}${this.url}`;
    return this.http.post<Product>(url, product, { headers: this.getHeaders() });
  }

  updateProduct(product: Product): Observable<Product> {
    const url = `${environment.url_web_services_path}${this.url}${product.rowid}/`;
    return this.http.put<Product>(url, product, { headers: this.getHeaders() });
  }

  deleteProduct(rowid: number): Observable<any> {
    const url = `${environment.url_web_services_path}${this.url}${rowid}/`;
    return this.http.delete(url, { headers: this.getHeaders() });
  }
}
